export default {
      id: "close-usage",
      viewBox: "0 0 14 13",
      url: __webpack_public_path__ + "img/icons.svg#close",
      toString: function () {
        return this.url;
      }
    }